import React, { useState, Suspense } from "react"
import { createPortal } from "react-dom"
import styled from "@emotion/styled"
import Button from "components/button/Button"
import { AnimatePresence, motion } from "framer-motion"
import FocusTrap from "focus-trap-react"
import { BootstrapModel } from "components/cards/beautyshot-card/BeautyshotCard"
import { useDictionary } from "contexts/Dictionary"
import { waTriggerEvent } from "../analytics/DigitalDataLayer"

import getMediaQuery from "css/breakpoints"
import { useConsole } from "contexts/Console"

const Main = styled.span`
  display: flex;
  position: absolute;
  z-index: 3;
  /* pointer-events: none; */
  inset: 0;

  align-items: end;
  justify-content: end;

  cursor: pointer;
`

const OpenButton = styled(Button)`
  --spacing: calc(var(--outer-margin) - var(--height) / 2);
  ${getMediaQuery("m")} {
    --spacing: calc(var(--outer-margin) - var(--grid-gap) / 2 - var(--height) / 2);
  }
  ${getMediaQuery("l")} {
    --spacing: calc((var(--outer-margin) - var(--grid-gap)) / 2 - var(--height) / 2);
  }

  /* position: absolute; */
  /* z-index: 1; */
  justify-self: end;
  pointer-events: auto;

  inset-block-end: 2rem !important;
  inset-inline-end: 2rem !important;
  position: relative !important;
  inset-inline-start: unset !important;
  transform: none !important;
`

const Close = styled(Button)`
  --spacing: calc(var(--outer-margin) - var(--height) / 2);
  ${getMediaQuery("m")} {
    --spacing: calc(var(--outer-margin) - var(--grid-gap) / 2 - var(--height) / 2);
  }
  ${getMediaQuery("l")} {
    --spacing: calc((var(--outer-margin) - var(--grid-gap)) / 2 - var(--height) / 2);
  }

  inset-block-start: var(--spacing);
  inset-inline-end: var(--spacing);

  position: fixed;
  z-index: 1;
`

const Underlay = styled(motion.div)`
  inset: 0;
  position: fixed;
  z-index: calc(var(--z-top, 10000));
`

const Modal = styled.div`
  background: linear-gradient(to top, #f0f0f0, #fff);
  height: 100vh;
  width: 100vw;
`

export default function BeautyshotButton({ style, children, parentTheme, fig_caption, beautyshot, ...props }) {
  const dictionary = useDictionary()
  const console = useConsole()
  const [isOpen, setIsOpen] = useState(false)
  const bodyElement = process.browser && document.body

  function onClose() {
    setIsOpen(false)
  }

  const { icon_style, asset, alt, rmc, theme } = beautyshot

  function onOpen() {
    setIsOpen(true)

    const currentLink = process.browser && window ? window.location.href : ""
    console.verbose(currentLink, "Current Link in BeautyshotButton")
    waTriggerEvent({
      eventName: "editoCardClicked",
      eventType: "Click",
      editoCardInfo: {
        name: rmc,
        url: "",
        category: "",
      },
    })
  }

  return (
    <Main style={style}>
      <OpenButton
        // ref={openButtonRef}
        aria_label={alt}
        icon='plus'
        className={`open-btn icon ${icon_style} ${theme ? theme : parentTheme?.theme ? parentTheme.theme : ""}`}
        onPress={onOpen}
      />
      {children}

      {process.browser &&
        createPortal(
          <AnimatePresence>
            {isOpen && (
              <FocusTrap focusTrapOptions={{ onDeactivate: onClose }}>
                <Underlay initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
                  <Modal aria-modal='true' role='dialog' aria-labelledby='beautyshot-modal-heading' aria-describedby='beautyshot-modal-content'>
                    <Close aria-label={dictionary.popinClose()} icon='close' className='icon translucent-light' onPress={onClose}>
                      <span>{dictionary.popinClose()}</span>
                    </Close>
                    <Suspense>
                      <BootstrapModel {...props} fig_caption={fig_caption} rmc={rmc} popin_image={asset} />
                    </Suspense>
                  </Modal>
                </Underlay>
              </FocusTrap>
            )}
          </AnimatePresence>,
          bodyElement
        )}
    </Main>
  )
}
